import moment from "moment";
import React from "react";
import "../style.css"; 

const TextCell = ({ value }) => (
  <div className="table-text-cell" title={value}>
    {value}
  </div>
);

export const IFSC_USER_MASTER_COLUMNS = [
  {
    Header: "IFSC Code",
    id: "ifscCode",
    accessor: d => <TextCell value={d.ifscCode} />
  },
  {
    Header: "Email ID",
    id: "emailId",
    accessor: d => <TextCell value={d.emailId} />,
    minWidth: 200,
    maxWidth: 300
  },
  {
    Header: "Corporate ID",
    id: "corporateId",
    accessor: d => <TextCell value={d.corporateId} />
  },
  {
    Header: "Bank Name",
    id: "bankName",
    accessor: d => <TextCell value={d.bankName} />,
    minWidth: 150,
    maxWidth: 300
  },
  {
    Header: "Created At",
    id: "createdAt",
    accessor: d => (
      <TextCell value={d.createdAt ? moment(d.createdAt).format("DD-MM-YYYY") : ''} />
    )
  }
];

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_NUMBER = 0;
